<template>
<div>
  
  <div class="table-wrapper-scroll-y my-custom-scrollbar mt-2">

  <table  class="table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col">#</th>    
        <th scope="col">DATA</th>
        <th scope="col">ORA</th>
        
        <th scope="col">ID</th>
        <th scope="col">Q.TA</th>
                
        <th v-if="isAdmin!=0" class="text-right">VALORE</th>
       
      </tr>
    </thead>
    <tbody>
      <tr data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">
        <td>{{index+1}}</td>
        <td>{{item.create_at}} </td>
        <td>{{item.time_at}} </td>
                
        <td class="text-right">{{item.total1}} </td>
        <td v-if="isAdmin != 0" class="text-right">{{fmt(item.total2)}} </td>
       
      </tr> 
    </tbody>
       <tfoot>
        <tr> 
        <td></td>        
        <td></td>
        <td></td>


        <td class="text-right">  {{total.total1}}</td>
        <td  v-if="isAdmin != 0" class="text-right">€ {{fmt(total.total2)}}</td>
            
               
        </tr>   
    </tfoot>    


  </table>

</div>


</div>


</template>
<script>



import api               from '@/api'  
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import {setFmtDate1} from '@/functions';   

export default {
    props : ['items'],
  components: {alertBox},
  data() {
    return {
      

     

      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],

      
    };
  },

  computed :{
    ...mapGetters(['company','isAdmin']),
    total : function()  {

      let total2 = 0
      let total1 = 0
      
      this.items.forEach(item =>
        {
          
          total2 += Number(item.total2)
          total1 += Number(item.total1)
        }
      )
      
      return {'total2':total2,'total1':total2}
    }
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {},
  methods: {
    fmt(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },
    }
}
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}
h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : #66CCFF; 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 20px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }



</style>